import { setupAnalytics } from './analytics/default';
import { loginSuccess } from './analytics/events/login';
import { pageFromNavigation } from './navigationHandler';
import { getUserId } from '../utilities/userTokenDetails';

const analytics = setupAnalytics();
const emailInputElementId = 'MemberLoginForm_LoginForm_Email';
const passwordInputElementId = 'MemberLoginForm_LoginForm_Password';

export const loginFormHandler = {
    loginForm: null,
    userEmail: null,

    emailInputElementId,
    passwordInputElementId,
    deviceEmailKey: 'fb_login_email',

    setupLoginPage: function () {
        this.loginForm = document.getElementById('MemberLoginForm_LoginForm');

        if (this.loginForm == null) {
            return;
        }

        if (this.isLoginModal()) {
            return;
        }

        this.prefillLoginFormDetails();
        this.onSubmit();
    },

    onSubmit: function () {
        this.loginForm.addEventListener('submit', (event) => {
            event.preventDefault();
            this.manageRememberEmailForDevice();

            if (
                !document.getElementById(this.emailInputElementId).validity.valid ||
                !document.getElementById(this.passwordInputElementId).validity.valid
            ) {
                return;
            }

            this.loginForm.submit();
        });
    },

    manageRememberEmailForDevice: function () {
        if (this.isRememberMeEnabled() === false) {
            this.removeEmailFromDevice();
            return;
        }

        this.saveEmailOnDevice();
    },

    prefillLoginFormDetails: function () {
        const savedEmail = this.getSavedEmail();

        if (savedEmail == null) {
            return;
        }

        this.setFormFieldProperties(this.emailInputElementId, {
            value: savedEmail,
        });

        this.setFormFieldProperties('MemberLoginForm_LoginForm_Remember', {
            checked: true,
        });
    },

    setFormFieldProperties: function (elementId, values) {
        const element = document.getElementById(elementId);

        if (element == null) {
            return;
        }

        Object.assign(element, values);
    },

    getSavedEmail: function () {
        return localStorage.getItem(this.deviceEmailKey);
    },

    saveEmailOnDevice: function () {
        this.setUserEmail();

        if (this.userEmail === null) {
            return;
        }

        localStorage.setItem(this.deviceEmailKey, this.userEmail);
    },

    removeEmailFromDevice: function () {
        localStorage.removeItem(this.deviceEmailKey);
    },

    isRememberMeEnabled: function () {
        const rememberMeElement = document.getElementById('MemberLoginForm_LoginForm_Remember');

        if (rememberMeElement == null) {
            return false;
        }

        return rememberMeElement.checked;
    },

    setUserEmail: function () {
        const emailInputElement = document.getElementById(this.emailInputElementId);

        if (emailInputElement == null) {
            return;
        }

        this.userEmail = emailInputElement.value;
    },

    isLoginModal: () => isLoginPage() === false,
};

export const loginPageEventHandler = () => {
    successfulLoginHandler();
};

export const successfulLoginHandler = () => {
    if (userLoginSuccess() === false) {
        return;
    }

    // when user's session times out and another user logs in, the initial user's id is used
    // reset the identity if you time out to prevent leakage between log ins in mixpanel
    analytics.resetIdentity();
    const userId = getUserId();

    if (userId == null) {
        return;
    }

    analytics.trackEvent(loginSuccess({ userId }));
};

// login url is valid for both "Login" & "login" (lowercase)
export const loginPagePath = '/Security/Login';
export const loginPagePathAlt = '/Security/login';
const getPathname = () => window.location.pathname;

const userReturnedFromLoginPage = () => {
    const { referrer } = document;

    return referrer.includes(loginPagePath) || referrer.includes(loginPagePathAlt);
};

const isLoginPage = () => getPathname() === loginPagePath || getPathname() === loginPagePathAlt;
const isContentPage = () => isLoginPage() === false;

// pageFromNavigation() account for page refresh and history traversal (forward / back)
// to prevent false logins events
const userLoginSuccess = () => isContentPage() && pageFromNavigation() && userReturnedFromLoginPage();
